import React from "react";

import { withRefluxStore } from "../../../Stores";
import DataVizStore from "../../../Stores/DataVizStore";

import PieChart from "../../../PagesUser/Campaign/DataVisualization/Charts/PieChart/PieChart";
import MetricCollector from "./../../../PagesUser/Campaign/DataVisualization/MetricCollector/MetricCollector";
import BarChart from "../../../PagesUser/Campaign/DataVisualization/Charts/BarChart/BarChart";
import PrintCard from "../PrintCard/PrintCard";
import * as SC from "./PrintInteractionMetrics.styled";
import PrintMetricsValue from "../PrintMetricsValue/PrintMetricsValue";
import { MetricTypes } from "../../../PagesUser/Campaign/DataVisualization/enums/metrics";
import { useTransformData } from "../../../PagesUser/Campaign/DataVisualization/hooks/use-transform-data.hook";

const PrintInteractionMetrics = ({
  chartData,
  minClicks = 0,
  // Store
  userProfile,
  selectedChannel
}) => {
  const cardKey = "engagementMetrics";

  const { result: transformedData, channelKeys } = useTransformData(
    chartData,
    selectedChannel.engagementMetrics
  );

  return (
    <PrintCard title={"Interaction"} fullWidth cardKey={cardKey}>
      {transformedData && (
        <SC.ChartsWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="Impressions"
              value={transformedData.allMetrics.impressions}
              type={MetricTypes.IMPRESSIONS}
              language={userProfile?.language}
            >
              <PieChart cardKey={cardKey} data={transformedData.totalImpressions} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.IMPRESSIONS}
              showChannels
              availableChannels={channelKeys}
              metricData={transformedData.totalImpressions}
            />
          </SC.ChartMetricWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="Clicks"
              value={transformedData.allMetrics.clicks}
              type={MetricTypes.CLICKS}
              language={userProfile?.language}
            >
              <PieChart cardKey={cardKey} data={transformedData.totalClicks} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.CLICKS}
              availableChannels={channelKeys}
              metricData={transformedData.totalClicks}
              minTarget={minClicks}
              totalTarget={transformedData.allMetrics.clicks}
            />
          </SC.ChartMetricWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="CTR avg."
              value={transformedData.allMetrics.ctr}
              unit={"%"}
              type={MetricTypes.CTR}
              language={userProfile?.language}
            >
              <BarChart data={transformedData.ctr} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.CTR}
              availableChannels={channelKeys}
              metricData={transformedData.ctr}
              unit={"%"}
              isFloatNumber
            />
          </SC.ChartMetricWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="Comments"
              value={transformedData.allMetrics.comments}
              type={MetricTypes.COMMENTS}
              language={userProfile?.language}
            >
              <PieChart cardKey={cardKey} data={transformedData.totalComments} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.COMMENTS}
              availableChannels={channelKeys}
              metricData={transformedData.totalComments}
            />
          </SC.ChartMetricWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="Reactions"
              value={transformedData.allMetrics.likes}
              type={MetricTypes.REACTIONS}
              language={userProfile?.language}
            >
              <PieChart cardKey={cardKey} data={transformedData.totalReactions} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.REACTIONS}
              availableChannels={channelKeys}
              metricData={transformedData.totalReactions}
            />
          </SC.ChartMetricWrapper>
          <SC.ChartMetricWrapper>
            <MetricCollector
              title="Shares"
              value={transformedData.allMetrics.shares}
              type={MetricTypes.SHARES}
              language={userProfile?.language}
            >
              <PieChart cardKey={cardKey} data={transformedData.totalShares} />
            </MetricCollector>
            <PrintMetricsValue
              type={MetricTypes.SHARES}
              availableChannels={channelKeys}
              metricData={transformedData.totalShares}
            />
          </SC.ChartMetricWrapper>
        </SC.ChartsWrapper>
      )}
    </PrintCard>
  );
};

export default withRefluxStore(
  PrintInteractionMetrics,
  [DataVizStore],
  ["selectedChannel", "userProfile"]
);
